import React, {
  createContext,
  memo,
  ReactNode,
  useContext,
  useMemo,
  useState,
} from "react";
import { Cor } from "../models/CorModel";

const valorInicial: Cor = {
  headerFooter: "#0946B8",
  fundoPadrao: "#FFFFFF",
  botaoSelecionado: "#04192E",
  botaoPadrao: "#148EFF",
  textoBotaoSelecionado: "#FFFFFF",
  textoBotaoPadrao: "#FFFFFF",
  textosInputs: "#4F4F4F",
  botaoSecundario: "#A9A9A9",
  textoBotaoSecundario: "#FFFFFF",
  tituloColuna: "#FFFFFF",
  textoTituloColuna: "#232323",
  bordaTituloColuna: "#000000",
  coluna: "#FFFFFF",
  textoColuna: "#4F4F4F",
  botaoMenu: "#717171",
  fundoMenu: "#FFFFFF",
  textoBotaoNormal: "#000000",
};

interface CoresProviderProps {
  children: ReactNode;
}

interface CoresContextType {
  dadosCoresRedux: Cor;
  setDadosCoresRedux: React.Dispatch<React.SetStateAction<Cor>>;
}

const Cores = createContext<CoresContextType | undefined>(undefined);

export const CoresContext: React.FC<CoresProviderProps> = memo(
  ({ children }) => {
    const [dadosCoresRedux, setDadosCoresRedux] = useState<Cor>(valorInicial);

    const contextValue = useMemo(
      () => ({
        dadosCoresRedux,
        setDadosCoresRedux,
      }),
      [dadosCoresRedux, setDadosCoresRedux]
    );

    return <Cores.Provider value={contextValue}>{children}</Cores.Provider>;
  }
);

export const useCor = () => {
  const context = useContext(Cores);
  if (!context) {
    throw new Error("useCor must be used within a CoresRedux");
  }
  return context;
};

export default Cores;
